module.exports = __webpack_public_path__ + "static/media/menuRightIcon.885794fc.svg";